<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <owners-crud></owners-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OwnersCrud from './owners/OwnersCrud';

    export default {

        components: {
            OwnersCrud
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.owners'),
                    },
                ]
            }
        },
    }
</script>
